import React from "react";
import { ViewId } from "@msidentity/SISU/constants/routing-constants";
import { useLocationCache } from "@msidentity/SISU/hooks";
import { MemberNameType } from "@msidentity/SISU/model/user";
import { useUsernameRecoveryContext } from "../../../username-recovery-context";
import { UsernameRecoveryBlockedViewFabric } from "../../blocked/fabric/username-recovery-blocked-view-fabric";
import { UsernameRecoveryChallengeViewFabric } from "../../challenge/fabric/username-recovery-challenge-view-fabric";
import { CollectProofViewFabric } from "../../collect-proof/fabric/username-recovery-collect-proof-view-fabric";
import { EnterCodeViewFabric } from "../../enter-code/fabric/username-recovery-enter-code-view-fabric";
import { PhoneSpeedbumpViewFabric } from "../../phone-speedbump/fabric/username-recovery-phone-speedbump-view-fabric";
import { ResultsViewFabric } from "../../results/fabric/username-recovery-results-view-fabric";
import { UsernameRecoverySelectAliasViewFabric } from "../../select-alias/fabric/username-recovery-select-alias-view-fabric";

export const ViewIdToViewMap: { [key: string]: JSX.Element } = {
  [ViewId.UsernameRecoveryPhoneSpeedbump]: <PhoneSpeedbumpViewFabric />,
  [ViewId.UsernameRecoveryLegacyCode]: <EnterCodeViewFabric />,
  [ViewId.Challenge]: <UsernameRecoveryChallengeViewFabric />,
  [ViewId.UsernameRecoveryResult]: <ResultsViewFabric />,
  [ViewId.UsernameRecoverySelectAlias]: <UsernameRecoverySelectAliasViewFabric />,
  [ViewId.UsernameRecoveryCollect]: <CollectProofViewFabric />,
  [ViewId.UsernameRecoveryBlocked]: <UsernameRecoveryBlockedViewFabric />,
};

/**
 * The initial view picker component for the Fabric Username Recovery flow.
 * @returns The initial View to render for the Username Recovery flow
 */
export const UsernameRecoveryInitialViewPickerFabric: React.FC =
  function UsernameRecoveryInitialViewPickerFabric() {
    const {
      viewState: { usernameVal, usernameType },
    } = useUsernameRecoveryContext();
    const cachedValues = useLocationCache(
      { usernameVal, usernameType },
      "usernameRecoveryInitialViewPicker",
    );
    let initialViewId = ViewId.UsernameRecoveryCollect;

    if (cachedValues.usernameVal && cachedValues.usernameType === MemberNameType.Phone) {
      initialViewId = ViewId.UsernameRecoveryPhoneSpeedbump;
    }

    if (cachedValues.usernameVal && cachedValues.usernameType === MemberNameType.EASI) {
      initialViewId = ViewId.UsernameRecoveryLegacyCode;
    }

    return ViewIdToViewMap[initialViewId];
  };
